import { gql } from "@apollo/client";
import { TOPIC_ADDITIONAL_FIELDS_FRAGMENT } from "../fragments/TopicFragments";

const GET_TOPIC_DETAILS = gql`
  query TopicDetails($id: ID!) {
    topicDetails(id: $id) {
      topic {
        ...TopicAdditionalFields
        chapter {
          id
          name
        }
        category {
          id
          name
        }
        materials {
          id
          learningMaterialLink
          audioLink
          city {
            id
            name
          }
        }
        cities {
          id
          name
        }
      }
      myTopic {
        cities {
          id
          name
        }
        skipped
        studied
        studiedCount
      }
    }
  }
  ${TOPIC_ADDITIONAL_FIELDS_FRAGMENT}
`;

export default GET_TOPIC_DETAILS;
